module.exports = __webpack_public_path__ + "static/media/tiktok.6bbabac6.svg";